export default "__VITE_ASSET__Cb_bZJIe__"